<template>
    <div class="materi-page">
        <div class="container-fluid mt-1">
            <div class="row">
                <div class="col-xl-12 mb-5 mb-xl-0">
                    <card header-classes="bg-transparent" body-classes="bg-transparent p-0">
                        <div slot="header" class="row align-items-center">
                            <div class="col-lg-6">
                                <h6 class="text-uppercase ls-1 mb-1">Download Nilai </h6>
                            </div>
                            <div class="col-lg-6 text-lg-right">
                                
                            </div>
                        </div>
                        <div class="text-center text-muted">
                            <div class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
                                <div class="p-2">
                                    <b-row>
                                        <b-col lg="2" class="my-1">
                                            <b-input-group size="sm">
                                                <b-form-select
                                                    v-model="setting_form.tahun_ajaran_id"
                                                    name="tahun_ajaran_id"
                                                    value-field="id"
                                                    text-field="name"
                                                    placeholder="Tahun Ajaran"
                                                    data-vv-as="Tahun Ajaran"
                                                    :options="taList"
                                                ></b-form-select>
                                                <template #first>
                                                    <b-form-select-option :value="null" disabled>Pilih Tahun Ajaran</b-form-select-option>
                                                </template>
                                            </b-input-group>
                                        </b-col>
                                        <b-col lg="2" class="my-1">
                                            <b-input-group size="sm">
                                                <b-form-select
                                                    v-model="setting_form.semester"
                                                    name="semester"
                                                    placeholder="Semester"
                                                    data-vv-as="Semester"
                                                    :options="semesterList"
                                                ></b-form-select>
                                            </b-input-group>
                                        </b-col>
                                        <b-col lg="2" class="my-1">
                                            <b-input-group size="sm">
                                                <b-button 
                                                    :disabled="!setting_form.semester"
                                                    variant="primary" 
                                                    style="border-radius:0px !important;" 
                                                    class="btn btn-danger" 
                                                    @click="downloadExcel(setting_form)">
                                                    Download Excel
                                                </b-button>
                                            </b-input-group>
                                        </b-col>
                                    </b-row>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import axios from '../../../axiosHelper';
    export default {
        props: {
            type: {
                type: String,
                default: null
            },
            semesterList: {
                type: Array,
                default () {
                    return [
                        {
                            value:'1',
                            text:'Ganjil',
                        },
                        {
                            value:'2',
                            text:'Genap',
                        },
                    ]
                }
            }
        },
        components: {
        },
        data() {
            return {
                classId: this.$route.params.classId,
                isBusy: false,
                showLoader: false,
                filter_form: {
                    activityId: null,
                },
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                filterOn: [],
                setting_form: {
                    semester: null,
                    tahun_ajaran_id: null,
                },
            }
        },
        computed: {
            ...mapGetters({
                token: 'getToken',
                taList: 'getTaList'
            })
        },
        watch: {
            //
        },
        methods: {
            downloadExcel(param) {
                let token = this.token
                let classId = this.$route.params.classId
                let route = axios.defaults.baseURL+'/v1/student-progress/download-nilai/'+classId+'/'+param.tahun_ajaran_id+'/'+param.semester+'?token='+token
                window.open(route);
            },
            async getTaList() {
                this.isBusy = true
				await this.$store.dispatch('getTaList')
					.then(() => {
                        this.isBusy = false
					})
					.catch((err)=> {
                        this.isBusy = false
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
        },
        destroyed() {
            // let resp = null
        },
        mounted() {
            //
        },
        async created() {
            await this.getTaList()
        }
    }
</script>
<style>
.task-name {
    padding-right: 0 !important;
}
.table-perkembangan {
    width: 100%;
    margin: 20px auto;
    table-layout: auto;
    border: 1px solid #555;
    border-width: 0 1px 0 1px;
}
.t-column-header {
    border: 1px solid #555;
    border-width: 0px 1px 0px 1px;
}
.t-column-body {
    border: 1px solid #555;
    border-width: 1px 1px 1px 1px;
}

</style>
<style lang="css" scoped>
.btn-primary {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
}
.table-responsive {
    margin-bottom: 0;
}
.btn-primary:hover, .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:focus {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
    -webkit-box-shadow: unset;
    box-shadow: unset;
}
#student-progress {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#student-progress td, #student-progress th {
  border: 1px solid #ddd;
  padding: 8px;
}

#student-progress tr:nth-child(even){background-color: #f2f2f2;}

#student-progress tr:hover {background-color: #ddd;}

#student-progress th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: center;
  background-color: #d40000;
  color: white;
}
</style>